<template>
  <div class="acvivity">
    <van-nav-bar class="nav-bar" right-text="活动规则" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
    <div class="container">
      <div class="img-warper">
        <div class="img">
          <div class="des">
            <div class="money"><span class="icon">￥</span><span class="num">{{money}}</span></div>
            <div class="tip">{{tip}}</div>
          </div>
        </div>
      </div>
      <div class="ifo">
        <p>活动任务</p>
        <template v-if="pageType === '0'">
          <div class="ifo-item" v-for="(item, index) in list" :key="index">
            <div class="left">
              <img :src="item.detailType === 1 ? zhiye : personIfo" alt="">
            </div>
            <div class="center">
              <div class="title">{{ item.detailType === 1 ? '执业认证' : '个人资料'}}</div>
              <div class="des">{{ item.detailType === 1 ? '上传执业认证且平台审核通过后任务将自动完成。' : '上传执业认证且平台审核通过后任务将自动完成。'}}</div>
            </div>
            <div class="right" :class="{'color-grey': item.status !== 2 && item.status}" @click="toActivity(item)">{{getText(item)}}</div>
          </div>
        </template>
        <div class="ifo-item" v-else>
          <div class="left">
            <img src="./imgs/heart.png" alt="">
          </div>
          <div class="center">
            <div class="title">邀新得红包</div>
            <div class="des">邀请一位律师完成认证并审核通过后奖励将自动发放。</div>
          </div>
          <!-- 如果没有完成认证任务，按钮置灰 -->
          <div class="right" :class="{'color-grey': !list[0]}" @click="toShare">去完成</div>
        </div>
      </div>
      <div class="notice">
        <notice />
      </div>
    </div>
    <van-dialog v-model="ruleShow" title="活动规则" :showConfirmButton='false' closeOnClickOverlay>
      <div class="content">
        <p>一、活动时间：</p>
        <p style="color:red;">二、2021年8月18日 ~ 2021年10月09日</p>
        <p>三、活动对象：</p>
        <p>长律app平台需认证律师的用户，仅限前1000名律师参与</p>
        <p>四、活动内容：</p>
        <p>活动期间内，用户通过提交个人资料进行律师认证，平台对认证资料进行审核，审核通过的律师可获得一次新用户奖励金，奖励金将自动发放至平台钱包余额。老用户邀请一位新用户（提交个人认证资料并通过平台审核后），可获得一次奖励金，新用户也可获得一次新用户奖励金，均发放至平台的钱包余额。</p>
        <p>五、活动奖励规则：</p>
        <p>1、在活动期间内，每个新用户注册并完成律师认证可获得一次新用户奖励金，老用户邀请新用户注册并通过律师认证仅可获得一次邀新奖励金。</p>
        <p>2、平台奖励金可进行提现，也可用于平台内部消费使用。</p>
        <p>3、如出现不可抗力（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动遭受严重网络攻击或因系统故障等）导致活动需要停止或调整的，平台有权终止活动而无需向用户进行赔偿或补偿。</p>
        <p>4、如参与本活动的用户存在任何利用系统漏洞、外挂软件、插件、等手段或者工具套取活动奖励、扰乱活动规则、违背活动公平原则的行为我们有权撤销用户参与活动及奖励使用资格，并有权收回用户已经获得的权益。</p>
        <p>5、在参与活动过程中，如用户出现认证资料作弊等违法违规行为我们有权撤销用户参与活动及奖励使用资格，并有权收回用户已经获得的权益。</p>
        <p>6、活动时间和活动奖励以界面展示为准，平台对本次活动享有最终解释权。</p>
        <p>7、本次活动与苹果公司（Apple Inc.）无关。</p>
        <p></p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { POINT_CODE, BURY_POINT_TYPE } from "@/libs/config";
import { priceYuan } from "@/libs/tool";
import { buriedChannelPoint } from "@/api/common";
import { centerDetailList } from "@/api/activity";
import { callApp } from "@/libs/bridge";
import { Toast } from "vant";
import notice from "./notice";
export default {
  name: "acvivityIndex",
  components: {
    notice,
  },
  data() {
    return {
      ruleShow: false,
      zhiye: require("@/assets/imgs/activity/zhiye.png"),
      personIfo: require("@/assets/imgs/activity/person-ifo.png"),
      money: 4.9,
      tip: "活动奖励现金红包",
      list: [],
      pageType: "1",
    };
  },
  mounted() {
    this.pageType = this.$route.query.type;
    this.getCenterDetailList();
    this.buriedPointPage();
    // 通知 app 隐藏头部
    this.$nextTick(() => {
      console.log('调用 hideNavBar');
      callApp('hideNavBar')
    })
    
  },
  methods: {
    onClickLeft() {
      callApp("finishActivity");
    },
    onClickRight() {
      this.ruleShow = !this.ruleShow;
    },
    async buriedPointPage() {
      // pageType: 0:认证 1：邀新
      let params = {
        code:
          Number(this.pageType) === 0
            ? POINT_CODE.MARKET_TASK_AUTH_VISIT
            : POINT_CODE.MARKET_TASK_INVITE_VISIT,
        type: BURY_POINT_TYPE.PAGE,
      };
      console.log(params);
      await buriedChannelPoint(params);
    },
    getCenterDetailList() {
      // AUTH_ACTIVITY: 个人资料认证和执业执照认证
      // INVITE_ACTIVITY: 邀请律师认证获取红包
      console.log(this.pageType);
      const type = this.pageType === "0" ? "AUTH_ACTIVITY" : "INVITE_ACTIVITY";
      centerDetailList({ marketingCode: type }).then((res) => {
        this.type = type;
        this.list = (res.data && res.data.list) || [];
        this.money = priceYuan(res.data.award, 1);
      });
    },
    getText(item) {
      const status = { 1: "待审核", 2: "去完成", 3: "已完成" };
      return status[item.status] || "去完成";
    },
    toActivity(item) {
      if (item.status == 2) {
        // 如果第一条任务没有完成，就不能去第二条任务
        if (item.detailType === 2 && this.list[0].status !== 3) {
          Toast("请先完成执业认证");
          return;
        }
        callApp("toActivity", item);
      }
    },
    toShare() {
      if(this.list[0]) {
        callApp(
          "showShareDialog",
          window.location.origin + "/#/activity/other-share"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.acvivity {
  ::v-deep .van-icon {
    color: #111111;
  }
  ::v-deep .van-nav-bar__text {
    color: #111111;
  }
  .container {
    width: 100%;
    padding-top: 30px;
    .img-warper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .img {
        width: 330px;
        height: 140px;
        background-image: url("~@/assets/imgs/activity/redTag.png");
        background-position: center center;
        background-size: 330px 140px;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        .des {
          margin-left: 39px;
          height: 70px;
          max-width: 190px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .money {
            width: 77px;
            height: 40px;
            font-size: 52px;
            color: #fff5dc;
            line-height: 40px;
            .icon {
              font-size: 24px;
            }
          }
          .tip {
            height: 20px;
            font-size: 14px;
            color: #fadeb2;
            line-height: 20px;
            margin-top: 10px;
          }
        }
      }
    }
    .ifo {
      padding: 26px 16px 0;
      > p {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #111111;
        line-height: 25px;
      }
      .ifo-item {
        height: 97px;
        width: 100%;
        border-bottom: 1px solid #f6f6f6;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          > img {
            width: 48px;
            height: 48px;
          }
          margin-right: 24px;
        }
        .center {
          width: 160px;
          height: 48px;
          .title {
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            color: #111111;
            line-height: 22px;
          }
          .des {
            height: 17px;
            font-size: 12px;
            color: #999999;
            line-height: 17px;
          }
        }
        .right {
          cursor: pointer;
          width: 80px;
          height: 28px;
          margin-left: auto;
          background: #4a549e;
          border-radius: 22px;
          font-size: 14px;
          text-align: center;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
        }
        .color-grey {
          background: #c8c8c8;
        }
      }
    }
    .notice {
      position: fixed;
      bottom: 70px;
      left: 0;
      padding: 0 20px;
      ::v-deep .van-notice-bar {
        background: rgba(243, 71, 71, 0.1);
        border-radius: 11px;
        // border: 1px solid rgba(243, 71, 71, 0.3);
        padding:2px 5px;
        font-weight: 600;
        .van-swipe-item {
          color: #f34747;
        }
      }
    }
  }
  .content {
    padding: 16px 16px 30px;
    max-height: 408px;
    overflow-y: scroll;
    font-size: 14px;
    color: #6b6b6f;
    line-height: 24px;
  }
}
</style>